import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import { Button, Stack, Typography } from '@mui/material';

import { PAGE_TYPES } from 'src/constants/module';
import useSimpleContentPage from 'src/hooks/useSimpleContentPage';
import { useUserContext } from 'src/components/app/context/UserContext';
import TextSkeleton from 'src/components/common/LoadingPage/textSkeleton';
import PageFrame from 'src/components/common/PageFrame';

const TermsPage = () => {
  const { acceptTermsOfUsage, user } = useUserContext();
  const { t } = useTranslation('common');
  const { pageContent, error, loading } = useSimpleContentPage(
    PAGE_TYPES.TERMS,
  );

  return (
    <PageFrame>
      {loading ? (
        <TextSkeleton />
      ) : error ? (
        <Typography color="error" sx={{ fontSize: 'large' }}>
          {error}
        </Typography>
      ) : (
        <>
          <Markdown>{pageContent}</Markdown>
          {user && !user.pro_terms_accepted && (
            <Stack sx={{ flexDirection: 'row', justifyContent: 'center' }}>
              <Button variant="cta" onClick={acceptTermsOfUsage}>
                {t('agree')}
              </Button>
            </Stack>
          )}
        </>
      )}
    </PageFrame>
  );
};

export default TermsPage;
